import {
    ConclusionKeys,
    FindingAreasEnum,
    getFindingAreaDisplayText,
    QuestionnaireFlowType,
    zodQuestionTypes
} from "../surveyStatusSchemas";

const questionnaireCompliance: QuestionnaireFlowType = {
    id: FindingAreasEnum.EmploymentTaxCompliance,
    name: getFindingAreaDisplayText(FindingAreasEnum.EmploymentTaxCompliance),
    questions: [
        {
            id: `${FindingAreasEnum.EmploymentTaxCompliance}:Q1`,
            text: "Are your filings and payments up to date in respect of payroll and employment taxes?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.EmploymentTaxCompliance}:Q2A`,
                no: `${FindingAreasEnum.EmploymentTaxCompliance}:Q2B`,
            },
        },
        {
            id: `${FindingAreasEnum.EmploymentTaxCompliance}:Q2A`, //Note: Q2A and Q2B are the same
            text: "Have you had any enquiries from HMRC within the last 6 years in respect of payroll/employment taxes?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.EmploymentTaxCompliance}:Q3A`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.EmploymentTaxCompliance}:Q2B`,
            text: "Have you had any enquiries from HMRC within the last 6 years in respect of payroll/employment taxes?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.EmploymentTaxCompliance}:Q3B`,
                no: ConclusionKeys.Amber,
            },
        },
        {
            id: `${FindingAreasEnum.EmploymentTaxCompliance}:Q3A`,
            text: "Has the enquiry been formally closed by HMRC?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Amber,
            },
        },
        {
            id: `${FindingAreasEnum.EmploymentTaxCompliance}:Q3B`,
            text: "Has the enquiry been formally closed by HMRC?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Red,
            },
        }
    ],
};

export default questionnaireCompliance;
